/* Dioter · landing — retire le widget Seal injecté dans les cartes de la landing (le choix cure est géré par la section) */
(function () {
  var KEEP = 'input[name="id"],input[name="quantity"],input[data-plan],input[name="form_type"],input[name="utf8"],input[name="product-id"],input[name="section-id"],.dt-add';
  function tidy(form) {
    Array.prototype.slice.call(form.children).forEach(function (c) { if (!c.matches(KEEP)) c.remove(); });
  }
  function run(scope) {
    (scope || document).querySelectorAll('.dt-card__form').forEach(function (f) {
      tidy(f);
      if (f.__dtObs) return;
      f.__dtObs = new MutationObserver(function () { tidy(f); });
      f.__dtObs.observe(f, { childList: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();
  window.addEventListener('load', function () { run(); });
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();

/* Dioter · Cure studio (section Cure 3 mois = pack de 3 flacons) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function eur(c) { return (Math.round(c) / 100).toFixed(2).replace('.', ',') + ' €'; }
  function init(root) {
    var cs = root.querySelector('[data-cs]'); if (!cs || cs.__cs) return; cs.__cs = true;
    var picks = cs.querySelector('[data-cs-picks]'); if (!picks) return;
    var cal = cs.querySelector('[data-cs-cal]'), form = cs.querySelector('[data-cs-form]');
    var opts = [].slice.call(cs.querySelectorAll('.dt-cs__opt'));
    var pct = +cs.dataset.pct || 0, ship = +cs.dataset.ship || 0;
    var o = function (k) { return cs.querySelector('[data-o="' + k + '"]'); };
    var state = { p: null, mode: 'cure' };

    function tween(el, to) {
      if (!el) return;
      var from = parseFloat(el.dataset.v); el.dataset.v = to;
      if (reduce || isNaN(from)) { el.textContent = eur(to); return; }
      var t0 = performance.now();
      (function f(t) { var k = Math.min(1, (t - t0) / 650), e = 1 - Math.pow(1 - k, 3); el.textContent = eur(from + (to - from) * e); if (k < 1) requestAnimationFrame(f); })(t0);
    }
    function data(b) {
      var d = b.dataset, price = +d.price, cure = Math.floor(price * 3 * (100 - pct) / 100);
      return { url: d.url, variant: d.variant, img: d.img, price: price, three: price * 3, cure: cure, unit: Math.floor(price * (100 - pct) / 100),
        avail: d.avail !== 'false', max: d.max === undefined ? 999 : +d.max };
    }
    function render() {
      var p = state.p; if (!p) return;
      var canCure = p.avail && p.max >= 3;
      if (state.mode === 'cure' && !canCure) state.mode = 'one';
      var m = state.mode, isCure = m === 'cure';
      var sm = o('stock');
      if (sm) {
        sm.hidden = canCure;
        sm.textContent = !p.avail ? sm.dataset.tOut : sm.dataset.tCureoff;
      }
      var btn = form.querySelector('button[type="submit"]'); if (btn) btn.disabled = !p.avail;
      opts.forEach(function (l) {
        var k = l.dataset.opt;
        l.classList.toggle('is-off', k === 'cure' && !canCure);
        l.classList.toggle('is-sel', k === m);
        l.querySelector('input').checked = k === m;
      });
      tween(o('one'), p.price); tween(o('cure'), p.cure);
      o('was').textContent = pct ? eur(p.three) : '';
      o('unit').textContent = 'Soit ' + eur(p.unit) + ' / flacon · livrés ensemble';
      o('save-l').textContent = isCure ? 'Vous économisez' : 'Économie avec la cure';
      tween(o('save'), p.three - p.cure);
      o('mode').textContent = isCure ? '3 flacons · 1 seule livraison' : '1 flacon · 1 mois';
      [].slice.call(cs.querySelectorAll('.dt-cs__month')).forEach(function (el, i) { el.classList.toggle('is-off', !isCure && i > 0); });
      var total = isCure ? p.cure : p.price;
      if (o('ship') && ship) {
        var gap = ship - total;
        o('ship').innerHTML = gap <= 0 ? '<b>Livraison offerte</b> avec ' + (isCure ? 'la cure' : 'ce flacon')
          : (!isCure && p.cure >= ship) ? 'Avec la cure, la <b>livraison est offerte</b>'
          : 'Plus que <b>' + eur(gap) + '</b> pour la livraison offerte';
      }
      form.querySelector('[name="id"]').value = p.variant;
      form.querySelector('[name="quantity"]').value = isCure ? 3 : 1;
      o('cta').textContent = isCure ? 'Ajouter la cure · ' + eur(p.cure) : 'Ajouter 1 flacon · ' + eur(p.price);
      o('link').href = p.url;
    }
    function choose(b, swap) {
      [].slice.call(picks.children).forEach(function (x) { x.setAttribute('aria-checked', String(x === b)); });
      state.p = data(b);
      [].slice.call(cs.querySelectorAll('[data-cs-img]')).forEach(function (img) { if (state.p.img) img.src = state.p.img; });
      if (swap && cal && !reduce) { cal.classList.remove('is-swap'); void cal.offsetWidth; cal.classList.add('is-swap'); }
      render();
    }
    picks.addEventListener('click', function (e) { var b = e.target.closest('.dt-cs__pick'); if (b) choose(b, true); });
    picks.addEventListener('keydown', function (e) {
      if (['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].indexOf(e.key) < 0) return;
      var list = [].slice.call(picks.children), i = list.indexOf(document.activeElement); if (i < 0) return;
      e.preventDefault(); var n = list[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : list.length - 1)) % list.length];
      n.focus(); choose(n, true);
    });
    opts.forEach(function (l) { l.querySelector('input').addEventListener('change', function () { state.mode = l.dataset.opt; render(); }); });
    cs.addEventListener('pointermove', function (e) {
      var r = cs.getBoundingClientRect();
      cs.style.setProperty('--mx', (e.clientX - r.left) + 'px'); cs.style.setProperty('--my', (e.clientY - r.top) + 'px');
    });
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { cs.classList.add('is-in'); io.disconnect(); } }); }, { threshold: 0.25 });
      io.observe(cal || cs);
    } else cs.classList.add('is-in');
    /* Un widget d'app peut s'injecter dans les formulaires d'ajout au panier */
    var tidy = function () { [].slice.call(form.children).forEach(function (c) { if (!c.matches('input,.dt-btn')) c.remove(); }); };
    tidy(); new MutationObserver(tidy).observe(form, { childList: true });
    choose(picks.querySelector('[aria-checked="true"]') || picks.firstElementChild, false);
  }
  function run(scope) { [].slice.call((scope || document).querySelectorAll('[data-dt="cure-studio"]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
